import { useRivalsSawPlayButtonOnboarding } from '@sorare/core/src/hooks/rivals/useRivalsSawPlayButtonOnboarding';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';
import useLifecycle, { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';

export const useRivalsOnboarding = () => {
  const {
    flags: { enableNewRivalsOnboarding = false },
  } = useFeatureFlags();
  const { update, lifecycle } = useLifecycle();
  const sawPlayButtonOnboarding = useRivalsSawPlayButtonOnboarding();

  return {
    onboardingEnabled: enableNewRivalsOnboarding,
    onboardingDone:
      lifecycle?.[LIFECYCLE.sawRivalsOnboarding] || sawPlayButtonOnboarding,
    markOnboardingAsDone: async () =>
      update(LIFECYCLE.sawRivalsOnboarding, true),
  };
};
